<template>
    <hm-content>
        <div class="flex flex-between">
            <el-button type="primary" size="small" @click="addGoods">新增选品</el-button>
            <div class="flex-end">
                <el-select placeholder="请选择产品线" v-model="conditionSearch.goodsLineId" clearable class="mr10" size="small">
                    <el-option v-for="(v,i) in selectionList"
                        :label="v.name"
                        :value="v.id"
                        :key="i"
                    ></el-option>
                </el-select>
                <el-input class="mr10" placeholder="请输入商品名称/货号" size="small" v-model="conditionSearch.queryWord" clearable style="width: 200px;"></el-input>
                <el-select placeholder="请选择商品状态" v-model="conditionSearch.saleState" clearable class="mr10" size="small">
                    <el-option v-for="(v,i) in goodsStatus"
                        :label="v.label"
                        :value="v.value"
                        :key="i"
                    ></el-option>
                </el-select>
                <el-button class="mr10"  size="small" type="primary" @click="conditionQuerySelection">查询</el-button>
                <el-button class="mr10" size="small" @click="outputExcel" type="primary">导出</el-button>
            </div>
        </div>
        <div class="flex flex-end" style="margin: 20px 0;">
            <div>
                <el-button class="mr10" type="text" icon="el-icon-picture-outline" style="color: #2B2B2B; font-size: 16px;">一键更新图片</el-button>
                <el-button class="mr10"  type="text" icon="el-icon-remove-outline" style="color: #2B2B2B; font-size: 16px;" @click="BatchDiscontinued('no')">批量停售</el-button>
                <el-button class="mr10"  type="text" icon="el-icon-circle-check" style="color: #2B2B2B; font-size: 16px;" @click="BatchDiscontinued('yes')">批量启售</el-button>
            </div>
        </div>
        <div style="margin-top: 10px;">
            <el-table
                :data="goodsList"
                ref="goodsListRel"
            >
                <el-table-column
                        type="selection"
                        align="center"
                        width="55"
                >
                </el-table-column>
                <el-table-column
                    align="cneter"
                    label="序号"
                    type="index"
                    width="55"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                    align="center"
                    label="商品名称"
                    width="300"
                    prop="spuName"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品货号"
                        prop="goodsSn"
                >
                    <template slot-scope="scope">
                        <span  style="cursor:pointer;" @click="edit(scope.row)">{{scope.row.goodsSn}}</span>
                    </template>
                </el-table-column>

                <el-table-column
                        align="center"
                        label="商品类型"
                        prop="isOverseas"
                        width="150"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isOverseas === 'yes'">跨境购</span>
                        <span v-else>一般</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="商品状态"
                        prop="saleState"
                        width="100"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.saleState === 'yes'" style="color: green">在售</span>
                        <span v-else style="color:red;">停售</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="商品采购价"
                        width="150"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showPurchasePrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="建议零售价"
                        width="150"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showRecommendedRetailPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="选品总库存"
                        prop="totalStockNum"
                        width="150"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="选品剩余库存"
                        prop="totalActualStockNum"
                        width="120"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="产品线"
                >
                    <template slot-scope="scope">
                        <el-button @click="editProductLine(scope)" size="small" type="text" style="color: #0081E5;">{{scope.row.goodsLineName}}</el-button>
                        <el-dialog :visible="editProductLineWindow" title="更改产品线" width="30%" center @close="editProductLineWindow = false" :modal="false" >
                            <div>
                                <span style="margin-top: 20px;">原产品线为：{{goodsLineName}}</span>
                                <div  style="margin-top: 20px;">
                                    <span>更改为：</span>
                                    <el-select v-model="pitch_On.id" size="small">
                                        <el-option
                                                v-for="(v,i) in selectionList"
                                                :label="v.name"
                                                :value="v.id"
                                                :key="i"
                                        ></el-option>
                                    </el-select>
                                    <el-button type="text" size="small" style="margin-left: 15px;" @click="addProductLineWindow = true">新增产品线</el-button>
                                </div>
                                <div slot="footer" class="dialog-footer" style="margin-top: 20px; text-align: center">
                                    <el-button @click="editProductLineWindow = false" size="small">取 消</el-button>
                                    <el-button type="primary" @click="changeProductLine(scope)" size="small">确 定</el-button>
                                </div>
                                <el-dialog :visible="addProductLineWindow" title="新增产品线" width="30%" center append-to-body @close="addProductLineWindow = false">
                                    <div>
                                        <div  style="margin-top: 20px;">
                                            <el-form :model="addGoodsLineName">
                                                <el-form-item label="产品线名称:" :label-width="formLabelWidth">
                                                    <el-input v-model="addGoodsLineName.name" autocomplete="off" placeholder="请输入产品线名称"></el-input>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                        <div slot="footer" class="dialog-footer" style="margin-top: 20px; text-align: center">
                                            <el-button @click="addProductLineWindow = false" size="small">取 消</el-button>
                                            <el-button type="primary" @click="addProductLine" size="small">确定添加</el-button>
                                        </div>
                                    </div>
                                </el-dialog>
                            </div>
                        </el-dialog>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="缺失信息"      
                        width='100'                  
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.missInfo!==''" style="color:red;cursor:pointer;" @click="edit(scope.row)">{{scope.row.missInfo}}</span>
                        <span v-else style="color:green">无缺失</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                        align="center"
                        label="操作"
                        fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button type="text" style="margin-left: 0; color: #0081E5;" @click="priceControlOpenWindow(scope.row)">价格及库存管理|</el-button>
                        <el-button type="text" style="margin-left: 0; color: green;" @click="haltSales(scope,'no')" v-if="scope.row.saleState == 'yes'">在售</el-button>
                        <el-button type="text" style="margin-left: 0; color: red;" @click="haltSales(scope,'yes')" v-else>停售</el-button>
                    </template>

                </el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="total"
                        @current-change="paging"
                        @size-change="handleSizeChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPage"
                ></el-pagination>
            </div>
            <!--新增选品窗口-->
            <el-dialog
                title="新增选品"
                :visible.sync="addGoodsWindow"
            >
                <el-button type="primary" size="small" class="mr10" @click="outPutExcelModel">导出模板</el-button>
                <p style="font-size: 12px; color: #666666; line-height: 40px;">请不要随意修改excel模板中的字段</p>
                <div class="flex">
                    <el-upload
                            class="mr10"
                            action=""
                            :on-change="handleChange"
                            :on-remove="handleRemove"
                            :on-exceed="handleExceed"
                            :limit="limitUpload"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            :auto-upload="false">
                        <el-button size="small" type="primary">导入商品</el-button>
                    </el-upload>
                    <p style="font-size: 12px; color: #666666; line-height: 40px;">将弹窗右下角的选择xlx文件改为选择所有文件，否则无法看到其它格式文件</p>
                </div>
                <div slot="footer" class="dialog-footer flex-center">
                    <el-button @click="addGoodsWindow = false">取 消</el-button>
                    <el-button type="primary" @click="commitAddGoods">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="价格及库存管理" :visible.sync="priceControlWindow">
                <p style="margin: 15px 0; font-size: 14px;">{{checkRow.spuName}}</p>
                <el-table
                    :data="checkRowGoodsMsg"
                    border
                    :span-method="objectSpanMethod"
                    size="mini"
                    stripe
                >
                    <el-table-column
                        align="center"
                        label="规格"
                        prop="specIdGroupName"
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="条码"
                            prop="barcode"
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="剩余库存"
                            width="150px"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.actualStockNum" style="width: 126px;" size="mini" min="0" type="number" @blur="checkPrice(scope.row.actualStockNum)">
                                <template slot="append" style="width: 26px;">件</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="分组"
                            prop="tagName"
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="建议零售价"
                            width="150px"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.recommendedRetailPrice"
                                      style="width: 126px;"
                                      size="mini"
                                      type="number"
                                      @blur="checkPrice(scope.row.recommendedRetailPrice,scope.row)">
                                <template slot="prepend" style="width: 26px;">￥</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            width="150px"
                            label="最低零售价"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.minRetailPrice"
                                      style="width: 126px;"
                                      size="mini"
                                      min="0"
                                      type="number"
                                      @blur="checkPrice(scope.row.minRetailPrice)">
                                <template slot="prepend" style="width: 26px;">￥</template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            width="150px"
                            label="采购价"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.purchasePrice"
                                      style="width: 126px;" size="mini"
                                      min="0" type="number"
                                      @blur="checkPrice(scope.row.purchasePrice)">
                                <template slot="prepend" style="width: 26px;">￥</template>
                            </el-input>
                        </template>
                    </el-table-column>

                </el-table>
                <div class="flex flex-center" style="margin-top: 30px;">
                    <el-button type="primary" class="mr10" @click="priceControlSave" :disabled=flag>保存</el-button>
                    <el-button class="mr10" @click="priceControlWindow = false">取消</el-button>
                </div>
            </el-dialog>
        </div>
    </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
    data(){
        return{
            goodsStatus:[
                {
                    label:'停售',
                    value:'no'
                },
                {
                    label:'在售',
                    value:'yes'
                },
            ],
            goodsLineName:'', //产品线名称
            missInfo:'',    //
            checkRowGoodsMsg:[{
                tagRelModelList:[]
            }
            ],
            priceControlWindow:false,
            formLabelWidth: '120px',
            addGoodsLineName: {
                name:''
            },  //新增产品线名称
            addProductLineWindow:false, //新增产品线窗口
            pitch_On: {
                name:'',
                id:''
            },  //选中的产品线
            selectionList: [],  //产品线列表
            editProductLineWindow:false,   //编辑产品线窗口
            limitUpload:1,
            fileTemp:null,
            file:null,
            da:[],
            dalen:0,
            //
            addGoodsWindow:false,   //新增选品窗口
            goodsList:[],       //选品列表
            total:0,     //总条数
            currentPage: 1,
            pageSize: 10,
            conditionSearch: {
                goodsLineId:'',
                saleState:'',
                queryWord:'',
            },   //条件查询
            editProductLineParameter:{   //修改产品线
                id:"",
                goodsLineId:"",
            },
            editStatu:{
                id:'',
                saleState:''
            },
            checkRow:[],
            flag:true,
            tagRelModelList:[],
            oldList: [],
            outputList:[],
        }
    },
    mounted() {
        this.searchSelectiList();
        this.queryPageList();
    },
    methods:{
        objectSpanMethod({row, column, rowIndex, columnIndex}){
            if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {  //选择合并哪一列
                return {
                    rowspan: row.rowspan,  //要合并的行数
                    colspan: 1
                };

            }
        },
        async BatchDiscontinued(status){   //批量停售方法
            let selectCheck = this.$refs.goodsListRel.selection;
            let params = {
                idList:[],
                saleState:status
            }
            selectCheck.forEach(v => {
                params.idList.push(v.id)
            });
            await this.$store.dispatch('batch_edit',params);
            this.$message({
                message: `批量停售成功`,
                type: 'success'
            });
            this.queryPageList();
        },
        checkPrice(val,row){
            console.log("scope.row =========>",row)
            if (val < 0){
                this.$message({
                    message: `不能输入负数`,
                    type: 'warning'
                });
                val = 0;
                this.flag = true;
            }else{
                this.flag = false;
            };

            console.log(val,this.flag);
        },
        //价格管理
        async priceControlSave(){
            console.log("this.checkRowGoodsMsg", this.checkRowGoodsMsg)
            this.checkRowGoodsMsg.forEach(v => {
                this.oldList.forEach(item => {
                    if (v.id == item.id && v.rowspan != 0) {
                        item.actualStockNum = v.actualStockNum;
                    }
                    if (v.id == item.id) {
                        item.tagRelModelList.forEach(j => {
                            if (v.detailId == j.id) {
                                j.minRetailPrice = v.minRetailPrice;
                                j.purchasePrice = v.purchasePrice;
                                j.recommendedRetailPrice = v.recommendedRetailPrice;
                            }
                        })
                    }

                })
            })
            console.log("oldList", this.oldList);
            await this.$store.dispatch("edit_sku_info",this.oldList);
            this.$message({
                message: `修改成功`,
                type: 'success'
            });
            this.priceControlWindow = false;
            this.queryPageList();
        },
        //价格管理窗体打开
        priceControlOpenWindow(val){
            this.priceControlWindow = true;
            this.flag = false;
            this.checkRow = val;
            this.priceControl();
        },
        isArray(arr) {
            return Object.prototype.toString.call(arr) === "[object Array]";
        },
        //价格管理方法
        async priceControl(){
            const { result } = await this.$store.dispatch("sku_info",{
                spuId:this.checkRow.spuId
            });
            this.tagRelModelList = result;
            this.checkRowGoodsMsg = [];

            this.oldList = JSON.parse(JSON.stringify(result));

            result.forEach(v => {
                v.tagRelModelList.forEach( (j,index) => {
                    let arr= {};
                    if (index == 0) {
                        arr.rowspan = v.tagRelModelList.length;
                    } else {
                        arr.rowspan = 0;
                    }
                    arr.specIdGroupName = v.specIdGroupName;
                    arr.id = v.id;
                    arr.detailId = j.id;
                    arr.actualStockNum = v.actualStockNum;
                    arr.barcode = v.barcode;
                    arr.minRetailPrice = j.minRetailPrice;
                    arr.purchasePrice = j.purchasePrice;
                    arr.recommendedRetailPrice = j.recommendedRetailPrice;
                    arr.tagName = j.tagName;
                    this.checkRowGoodsMsg.push(arr);
                })
            });


            console.log("this.checkRowGoodsMsg ==========>",this.checkRowGoodsMsg)
        },
        //商品停售
        async haltSales(scope,state){
            let vals = '';
            if (state == "no"){
                this.$confirm(`确定要将【${scope.row.spuName}】停售吗？一旦停售，下属分 销商的商品将不可销售，停售后不可再销售，请谨慎操作！！！`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    center:true,
                    type: 'warning'
                }).then(() => {
                    state = 'no'
                    this.editStatu.id = scope.row.id;
                    this.editStatu.saleState = state;
                    this.haltSalesFun(this.editStatu);
                    this.$message({
                        type: 'success',
                        message: '停售成功!'
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消停售'
                    });
                });
            }else if(state == "yes"){
                vals = "启售";
                this.editStatu.id = scope.row.id;
                this.editStatu.saleState = state;
                this.haltSalesFun(this.editStatu);
                this.$message({
                    message: `${vals}成功`,
                    type: 'success'
                });
            };
        },
        async haltSalesFun(value){
            await this.$store.dispatch("adit_goods_line",value);
            this.queryPageList();
        },
        //修改产品线
        async changeProductLine(scope){
            console.log(scope.row.id);
            this.editProductLineParameter.goodsLineId = this.pitch_On.id;
            await this.$store.dispatch("adit_goods_line",this.editProductLineParameter);
            this.$message({
                message: '修改成功',
                type: 'success'
            });
            this.editProductLineWindow = false;
            this.queryPageList();
        },

        //新增产品线
        async addProductLine(){
            await this.$store.dispatch("add_goods_line",this.addGoodsLineName);
            this.$message({
                message: '添加成功',
                type: 'success'
            });
            this.addProductLineWindow = false;
            this.searchSelectiList();
        },
        //查询产品线列表
        async searchSelectiList(){
            const { result } = await this.$store.dispatch("ProductLineList");
            console.log(result);
            this.selectionList = result;
        },
        //打开编辑产品线窗口
        editProductLine(scope){
            this.goodsLineName = scope.row.goodsLineName;
            this.editProductLineWindow = true;
            this.editProductLineParameter.id = scope.row.id;
            this.searchSelectiList();
        },
        //根据字段查询
        conditionQuerySelection(){
            this.queryPageList();
        },
        //提交excel中的选品信息
        async commitAddGoods(){
            const { result } = await this.$store.dispatch("importGoodsSelection",this.da);
                this.$message({
                    message: `导入成功,导入失败${result.fail.length}条，重复数据${result.repeat.length}条`,
                    type: 'success'
                });
                this.addGoodsWindow = false;
                this.queryPageList();
        },
        paging(page) {
            this.currentPage = page;
            this.queryPageList();
     //       this.queryList();
        },
        handleSizeChange(size) {
            this.currentPage = 1;
            this.pageSize = size;
            this.queryPageList();
     //       this.queryList();
        },
        //查询选品信息
        async queryPageList(queryAll){
            let params = {
               pageSize: queryAll ? 99999 : this.pageSize,
                pageNo: queryAll ? 1 : this.currentPage,
            }
            const conditionSearchs = JSON.parse(JSON.stringify(this.conditionSearch));
            Object.assign(params,conditionSearchs);
            const { result } = await this.$store.dispatch("ChooseProductnFormation",params);
            console.log(result.records);
            if(queryAll){
                this.outputList = result.records;
            }else{
                this.goodsList = result.records;
            }
            this.total =result.total;
        },
        //新增选品
        addGoods(){
            this.addGoodsWindow = true;
        },
        //缺失信息跳转
        edit(row) {
        this.$router.push({
            name: "EditGoods",
            query: {
            spuId: row.spuId
            }
        });
        },
        //导出excel模板
        outPutExcelModel(){
            require.ensure([], () => {
                const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
                let tHeader = ["商品名", "商品货号", "商品条码","期初库存","分组标签","建议零售价","最低零售价","采购价"];
                const filterVal = [];
                const data = this.formatJson(filterVal, []);
                let name = '商品导入模板';
                exportJsonToExcel(tHeader, data, name);
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]));
        },
        //从excel中导入商品数据
        //上传文件时处理方法
        handleChange(file, fileList){
            this.fileTemp = file.raw;
            if(this.fileTemp){
                if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                    || (this.fileTemp.type == 'application/vnd.ms-excel')){
                    this.importfxx(this.fileTemp);
                } else {
                    this.$message({
                        type:'warning',
                        message:'附件格式错误，请删除后重新上传！'
                    })
                }
            } else {
                this.$message({
                    type:'warning',
                    message:'请上传附件！'
                })
            }
        },
        handleExceed(){
            this.$message({
                type:'warning',
                message:'超出最大上传文件数量的限制！'
            })
            return;
        },
        handleRemove(file,fileList){
            this.fileTemp = null
        },
        importfxx(obj) {
            let _this = this;
            this.file = event.currentTarget.files[0];

            let rABS = false; //是否将文件读取为二进制字符串
            let f = this.file;

            let reader = new FileReader();
            //if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function(f) {
                let binary = "";
                let rABS = false; //是否将文件读取为二进制字符串
                let pt = this;
                let wb; //读取完成的数据
                let outdata;
                let reader = new FileReader();
                reader.onload = function(e) {
                    let bytes = new Uint8Array(reader.result);
                    let length = bytes.byteLength;
                    for (let i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    let XLSX = require("xlsx");
                    if (rABS) {
                        wb = XLSX.read(btoa(fixdata(binary)), {
                            //手动转化
                            type: "base64"
                        });
                    } else {
                        wb = XLSX.read(binary, {
                            type: "binary"
                        });
                    }
                    outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]); //outdata就是你想要的东西
                    console.log('未处理的原始数据如下：');
                    console.log(outdata);
                    //此处可对数据进行处理
                    let arr = [];
                    outdata.map(v => {
                        let obj = {}
                        obj.spuName = v['商品名']
                        obj.goodsSn = v['商品货号']
                        obj.barcode = v['商品条码']
                        obj.stockNum = v['期初库存']
                        obj.tagName = v['分组标签']
                        obj.recommendedRetailPrice = v['建议零售价']
                        obj.minRetailPrice = v['最低零售价']
                        obj.purchasePrice = v['采购价']
                        arr.push(obj)
                    });
                    _this.da=arr;
                    _this.dalen=arr.length;
                    return arr;
                };
                reader.readAsArrayBuffer(f);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        },
        outputExcel(){
            require.ensure([], () => {
                const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
                this.isOutputing = true;
                this.queryPageList("queryAll")
                    .then((res) => {
                        const list = this.outputList;
                        list.forEach(v => {
                            if (v.saleState == "yes") {
                                v.saleState = "在售";
                            } else if (v.saleState == "no") {
                                v.saleState = "停售";
                            };
                            if (v.isOverseas == "no") {
                                v.isOverseas = "否";
                            } else if (v.isOverseas == "yes") {
                                v.isOverseas = "是";
                            }
                        });
                        const tHeader = [
                            "商品名称",
                            "商品货号",
                            "是否跨境购商品",
                            "商品状态",
                            "商品采购价",
                            "建议零售价",
                            "选品总库存",
                            "选品剩余库存",
                            "产品线"
                        ];
                        const filterVal = [
                            "spuName",
                            "goodsSn",
                            "isOverseas",
                            "saleState",
                            "showPurchasePrice",
                            "showRecommendedRetailPrice",
                            "totalStockNum",
                            "totalActualStockNum",
                            "goodsLineName"
                        ];
                        const data = this.formatJson(filterVal, list);
                        exportJsonToExcel(
                            tHeader,
                            data,
                            "选品管理" + new Date().toLocaleString()
                        );
                        this.isOutputing = false;
                    })
                    .catch(() => {
                        this.isOutputing = false;
                    });
            });
        },
    }
}
</script>
<style></style>